<template>
  <div class="selected-model-container">
    <v-card>
      <div class="selected-model-card-header">
        <h1 class="title mb-8">Modelo de destaque {{ modelTitle }}</h1>
      </div>
      <div class="selected-model-config">
        <div class="mobile-frame-section">
          <mobile-frame height="580px">
            <template v-slot:mobile-content>
              <expanded-model v-if="isExpandedModel" />
              <default-model v-else />
            </template>
          </mobile-frame>
        </div>
        <div class="config-model-section">
          <config-expanded-model v-if="isExpandedModel" :banner-image-error="bannerImageError" />
          <config-default-model
            v-else
            :icon-image-error="iconImageError"
            :display-title-error="displayTitleError"
            :display-title-error-message="displayTitleErrorMessage"
          />
        </div>
      </div>
    </v-card>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { highlightOffer } from '../../../../mixins/highlight-offer'

export default {
  name: 'ConfigSelectedModel',
  components: {
    MobileFrame: () => import('../MobileFrame.vue'),
    ExpandedModel: () => import('../ExpandedModel.vue'),
    DefaultModel: () => import('../DefaultModel.vue'),
    ConfigExpandedModel: () => import('./ConfigExpandedModel.vue'),
    ConfigDefaultModel: () => import('./ConfigDefaultModel.vue'),
  },
  mixins: [highlightOffer],
  props: {
    displayTitleError: {
      type: Boolean,
      default: false,
    },
    displayTitleErrorMessage: {
      type: String,
      default: '',
    },
    iconImageError: {
      type: Boolean,
      default: false,
    },
    bannerImageError: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({}),
  computed: {
    ...mapGetters(['isExpandedModel']),
    modelTitle() {
      return this.isExpandedModel ? 'expandido' : 'padrão'
    },
  },
  methods: {},
}
</script>
<style lang="scss" scoped>
.selected-model-container {
  .v-card {
    padding: 24px 30px 0 30px;
    max-width: 100%;
    .selected-model-config {
      width: 100% !important;
      display: flex;
      flex-direction: row;
      gap: 145px;
      .mobile-frame-section {
        padding-left: 40px;
      }
      .config-model-section {
        width: 45%;
      }
    }
  }
}
</style>
